import { Cesium } from 'app/cesium';
import { ImageUrlService } from 'app/shared/image_url.service';
import { MapService } from 'app/map/services/map.service';

const SITE_DATA_SOURCE_NAME = 'SiteData';

/**
 * @ngdoc service
 * @name ims.map.service:MapSitesService
 * @description
 * The service used to store and control the way sites are displayed on the Cesium map.
 */
export class MapSitesService {
    constructor(mapService: MapService, imageUrlService: ImageUrlService) {}
}
